import { createFileRoute } from '@tanstack/react-router'
import { useRouteDigitalProductId } from '@/shared/hooks/useRouteDigitalProductId'

import { DigitalProductQuizShowPlay } from '@/features/quizzes/Show/Play'

export const Route = createFileRoute(
  '/_event/quizzes/$quizId/iniciar'
)({
  component: DigitalProductQuizShowPlayPage
})

function DigitalProductQuizShowPlayPage() {
  const digitalProductId = useRouteDigitalProductId()
  const { quizId } = Route.useParams()

  return (
    <DigitalProductQuizShowPlay digitalProductId={digitalProductId} id={quizId} />
  )
}
